import { Link } from 'react-router';

/** Anything that is not a real route. Kept short: there is nowhere else to go
    in an app with four tabs, so the fastest exit is the only useful content. */
export function NotFoundPage() {
  return (
    <section className="card stack center">
      <h1 className="h1">Yeh page nahi mila</h1>
      <p className="muted">Link purana ho sakta hai.</p>
      <Link className="btn" to="/">
        Project dekhiye
      </Link>
    </section>
  );
}
